import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {Headers} from '../../global/util/Headers';
import {Constant} from '../../global/util/Constant';
import {Workflow} from '../model/Workflow';
import {TemplateDesignWorkflow} from '../model/TemplateDesignWorkflow';
import {LocalStorage} from '../../global/util/LocalStorage';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  private url = Constant.ROOT_API_V1.concat('/workflows');

  constructor(private http: HttpClient) {
  }

  public get(url: string) {
    return this.http.get(url);
  }

  public save(workflow: Workflow): Observable<any> {
    return this.http.post(this.url, JSON.stringify(workflow), Headers.contentType);
  }

  public edit(workflow: Workflow): Observable<any> {
    return this.http.put(this.url, JSON.stringify(workflow), Headers.contentType);
  }

  public delete(workflowId: number): Observable<any> {
    const url = this.url.concat('?workflowId=').concat(String(workflowId));
    return this.http.delete(url);
  }

  public saveTemplateDesign(templateDesignWorkflow: TemplateDesignWorkflow): Observable<any> {
    const url = this.url.concat('/templatedesign');
    return this.http.post(url, JSON.stringify(templateDesignWorkflow), Headers.contentType);
  }

  public updateTemplateDesign(templateDesignWorkflow: TemplateDesignWorkflow): Observable<any> {
    const url = this.url.concat('/templatedesign');
    return this.http.put(url, JSON.stringify(templateDesignWorkflow), Headers.contentType);
  }

  public getTemplateDesignBy(workflowId: number): Observable<any> {
    const url = this.url.concat('/').concat(String(workflowId)).concat('/templatedesign');
    return this.http.get(url);
  }

  public duplicateBy(workflowId: number): Observable<any> {
    const url = this.url.concat('/').concat(String(workflowId)).concat('/duplicate');
    return this.http.post(url, new FormData());
  }

  getWorkflowsExtraBy(enterpriseId: number): Observable<Workflow[]> {
    return of(LocalStorage.getWorkflowsBy(enterpriseId));
  }
}
